import { Feather } from "@expo/vector-icons";

const settings = {
  // props type is `IconProps` but RNP doesn't export that type
  icon: (props: any) => <Feather {...props} />,
};

export default settings;
